import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "mitarbeiterindex" }
const _hoisted_2 = { class: "row smalltext" }
const _hoisted_3 = { class: "col-4 align-self-center" }
const _hoisted_4 = { class: "col-4 align-self-center" }
const _hoisted_5 = { class: "col-4 align-self-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "col-4 align-self-center"
}
const _hoisted_8 = {
  key: 1,
  class: "col-4 align-self-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", null, "<Kein Name>", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "col-4 align-self-center" }
const _hoisted_12 = { class: "col-4" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Headline = _resolveComponent("Headline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Headline, {
      h1: _ctx.$t('management.title')
    }, null, 8, ["h1"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('management.name')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('management.email')), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('management.unit')), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workers, (worker) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row listitem",
        key: worker.id,
        onClick: ($event: any) => (_ctx.navigate(worker.id))
      }, [
        (worker.lastname != '' || worker.firstname != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(worker.lastname) + " " + _toDisplayString(worker.firstname), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10)),
        _createElementVNode("div", _hoisted_11, _toDisplayString(worker.email), 1),
        _createElementVNode("div", _hoisted_12, [
          (worker.name == 'Keine Abteilung')
            ? (_openBlock(), _createElementBlock("i", _hoisted_13, "<" + _toDisplayString(worker.name) + ">", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(worker.name), 1))
        ])
      ], 8, _hoisted_6))
    }), 128))
  ]))
}